/* eslint-disable consistent-return */
import React, { FunctionComponent, useState, useEffect, Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector, useDispatch, RootStateOrAny } from 'react-redux'
import { getAllGenres } from 'Redux/actions/genresActions'
import { getAllMoods } from 'Redux/actions/moodsActions'
import { markMoodTooltipAsRead } from 'Redux/actions/notificationsActions'
import { getLanguagesForExistingPlaylists } from 'Redux/actions/languagesActions'
import CheckboxAntd from 'Containers/ui/CheckboxAntd'
import { Selects } from 'Constants/enums'
import SelectGenres from 'Shared/components/SelectGenres'
import SelectLanguages from 'Shared/components/SelectLanguages'
import { Mobile, Desktop } from 'Shared/components/Responsive'
import { Hint } from 'Stories/Hint/Hint.stories'
import { IconOrangeAlert, IconQuestionMark } from 'Stories/Icon/Icon.stories'
import { DottedBtn } from 'Stories/DottedBtn/DottedBtn.stories'
import { WhiteGreenBtn } from 'Stories/Button/Button.stories'
import ParamsSelect from 'Containers/ui/ParamsSelect'
import { getExistingPlaylistsLanguages } from 'Redux/selectors/languages'
import { Popover } from 'antd'
import GenresHintModal from '../GenresHintModal'
import LanguageHintModal from '../LanguageHintModal'
import GenresHint from '../GenresHint'
import LanguageHint from '../LanguageHint'
import { Language, Genre } from '../../Types'
import { TargetInfoContainerProps } from './TargetInfoContainerProps'

import {
  TargetInfo,
  TargetGenresTitle,
  MatchingInfoContainer,
  MatchingInfoIcon,
  WrapperForLanguageCheckbox,
  TargetLangTitle,
  GotItBtnContainer,
  NeedHelpGenresBtn,
  CopyOptionsWrapper,
  StyledPopover,
  Wrapper,
  BtnsWrapper,
  GlobalStyled,
} from './styles'

const TargetInfoContainer: FunctionComponent<TargetInfoContainerProps> = ({
  track,
  isCheckboxChecked,
  selectedSpotifyLanguagesLength,
  selectedSpotifyGenresLength,
  selectedTikTokLanguagesLength,
  showGenresNecessity,
  selectedGenres,
  selectGenres,
  modalArtistToggle,
  setIsCheckboxChecked,
  selectedLanguages,
  setSelectedLanguages,
  handleSetTikTokValuesCopy,
}) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const languages: Array<Language> = useSelector(getExistingPlaylistsLanguages)
  const allGenres: Array<Genre> = useSelector(
    (state: RootStateOrAny) => state.genres.genres
  )
  const moodTooltipShown: boolean = useSelector(
    (state: RootStateOrAny) => state.sessionNotifications.moodTooltipShown
  )

  const [modalGenre, setModalValueGenre] = useState<boolean>(false)
  const [modalVocal, setModalValueVocal] = useState<boolean>(false)
  const [genresSearchMobileMode, setGenreSearchMobileMode] = useState(false)
  const [languageSearchMobileMode, setLanguageSearchMobileMode] = useState(
    false
  )
  const [genresHint, setGenresHint] = useState<boolean>(false)
  const [languageHint, setLanguageHint] = useState<boolean>(false)

  const toggleModalGenresHint = () => setModalValueGenre(!modalGenre)
  const toggleModalLanguageHint = () => setModalValueVocal(!modalVocal)

  const toggleGenresHint = () => {
    if (languageHint) {
      setLanguageHint(false)
    }
    setGenresHint(!genresHint)
  }

  const toggleLanguageHint = () => {
    if (genresHint) {
      setGenresHint(false)
    }
    setLanguageHint(!languageHint)
  }

  const markTooltipAsRead = () => {
    setTimeout(() => {
      dispatch(markMoodTooltipAsRead())
    }, 5000)
  }

  useEffect(() => {
    if (!moodTooltipShown) {
      markTooltipAsRead()
    }
  }, [moodTooltipShown])

  useEffect(() => {
    dispatch(getAllGenres())
    dispatch(getAllMoods())
    dispatch(getLanguagesForExistingPlaylists())
  }, [])

  return (
    <Fragment>
      {track && (
        <TargetInfo>
          <div>
            <TargetGenresTitle>
              <div>{t('targetGenres.targetGenres')}</div>
              <Desktop>
                <StyledPopover>
                  <GlobalStyled />
                  <Popover
                    placement="leftBottom"
                    overlayClassName="overlayClassName"
                    visible={genresHint}
                    trigger="click"
                    content={
                      <Wrapper>
                        <GenresHint />
                        <BtnsWrapper>
                          <GotItBtnContainer>
                            <WhiteGreenBtn
                              color="white"
                              onClick={toggleGenresHint}
                            >
                              {t('scheduleCampaignPage.gotIt')}
                            </WhiteGreenBtn>
                          </GotItBtnContainer>
                        </BtnsWrapper>
                      </Wrapper>
                    }
                  >
                    <Hint onClick={toggleGenresHint}>
                      <IconQuestionMark />
                    </Hint>
                  </Popover>
                </StyledPopover>
              </Desktop>

              <Mobile>
                <Hint onClick={toggleModalGenresHint}>
                  <IconQuestionMark />
                </Hint>
                <GenresHintModal
                  isOpen={modalGenre}
                  toggle={toggleModalGenresHint}
                />
              </Mobile>
            </TargetGenresTitle>

            <SelectGenres
              selectedGenres={selectedGenres}
              setSelectedGenres={selectGenres}
              allGenres={allGenres}
              onMobileSearchOpen={() => {
                setGenreSearchMobileMode(true)
              }}
            />
            <ParamsSelect
              isSearchMode={genresSearchMobileMode}
              placeholder={t('createCampaignPage.startTypingGenreName')}
              itemsType="genres"
              listedItems={allGenres || []}
              //  @ts-ignore
              selectedItems={selectedGenres}
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              //  @ts-ignore
              setSelectedItems={selectGenres}
              onCloseClick={() => {
                setGenreSearchMobileMode(false)
              }}
            />
          </div>

          {selectedSpotifyGenresLength === 0 && showGenresNecessity && (
            <MatchingInfoContainer>
              <MatchingInfoIcon>
                <IconOrangeAlert />
              </MatchingInfoIcon>

              <div>
                {t(
                  'createCampaignPage.atLeastOneGenreNeedToBeSelectedToStartCampaign'
                )}
              </div>
            </MatchingInfoContainer>
          )}

          <Desktop>
            <NeedHelpGenresBtn>
              <DottedBtn
                content={t('createCampaignPage.needHelpToDefineGenres')}
                onClick={modalArtistToggle}
              />
            </NeedHelpGenresBtn>
          </Desktop>
          <Mobile>
            <NeedHelpGenresBtn>
              <DottedBtn
                content={t('createCampaignPage.needHelpToDefineGenres')}
                onClick={modalArtistToggle}
              />
            </NeedHelpGenresBtn>
          </Mobile>

          <div>
            <TargetLangTitle>
              <div>{t('targetLanguages.targetLanguage')}</div>
              <Desktop>
                <StyledPopover>
                  <GlobalStyled />
                  <Popover
                    placement="leftBottom"
                    overlayClassName="overlayClassName"
                    visible={languageHint}
                    trigger="click"
                    content={
                      <Wrapper>
                        <LanguageHint />
                        <BtnsWrapper>
                          <GotItBtnContainer>
                            <WhiteGreenBtn
                              color="white"
                              onClick={toggleLanguageHint}
                            >
                              {t('scheduleCampaignPage.gotIt')}
                            </WhiteGreenBtn>
                          </GotItBtnContainer>
                        </BtnsWrapper>
                      </Wrapper>
                    }
                  >
                    <Hint onClick={toggleLanguageHint}>
                      <IconQuestionMark />
                    </Hint>
                  </Popover>
                </StyledPopover>
              </Desktop>
              <Mobile>
                <Hint onClick={toggleModalLanguageHint}>
                  <IconQuestionMark />
                </Hint>
                <LanguageHintModal
                  isOpen={modalVocal}
                  toggle={toggleModalLanguageHint}
                />
              </Mobile>
            </TargetLangTitle>

            <SelectLanguages
              selectedLanguages={selectedLanguages}
              setSelectedLanguages={setSelectedLanguages}
              languages={languages}
              onMobileSearchOpen={() => {
                setLanguageSearchMobileMode(true)
              }}
            />
            <ParamsSelect
              isSearchMode={languageSearchMobileMode}
              placeholder={t('createCampaignPage.startTypingLanguageName')}
              itemsType="languages"
              listedItems={languages}
              //  @ts-ignore
              selectedItems={selectedLanguages}
              //  @ts-ignore
              setSelectedItems={setSelectedLanguages}
              onCloseClick={() => {
                setLanguageSearchMobileMode(false)
              }}
            />
          </div>

          {selectedSpotifyLanguagesLength > 0 ||
            (selectedTikTokLanguagesLength > 0 && (
              <WrapperForLanguageCheckbox>
                <CheckboxAntd
                  checked={isCheckboxChecked}
                  onChange={e => setIsCheckboxChecked(e.target.checked)}
                />
                <div>{t('createCampaignPage.targetOnlySelectedLanguages')}</div>
              </WrapperForLanguageCheckbox>
            ))}

          {handleSetTikTokValuesCopy && (
            <CopyOptionsWrapper>
              <DottedBtn
                content={t('createCampaignPage.copyOptionsFromSpotify')}
                onClick={() => handleSetTikTokValuesCopy(Selects.agree)}
              />
            </CopyOptionsWrapper>
          )}
        </TargetInfo>
      )}
    </Fragment>
  )
}

export default TargetInfoContainer
